import type { AssignmentPiece } from '@/types/Models/Assignment'

export const defaultPiece: AssignmentPiece = {
  quantity: 1,
  weight: 0,
  height: 0,
  length: 0,
  width: 0,
  description: '',
  commodity_code: '',
  estimated_cost: 0,
  origin_country_code: '',
}
